import {DatePicker as SlDatePicker} from "surveylabJsAssets/datetime/datepicker";
import {TempusDominus} from "@eonasdan/tempus-dominus";

/**
 * Override to use 'decades' calender view mode and custom placeholder for (birthday) element.
 */
const birthdayDateElementID = 'datepicker-item-id-1350';

export class DatePicker extends SlDatePicker {
    protected options(): {} {
        return $.extend(true, super.options(), {
            display: {
                viewMode: 'decades',
            },
        });
    }

    public createPicker(): void {
        // Hide element and remove input value temporarily, because the picker can't be initialized in case of invalid value
        $(this.target).hide();
        const $inputElement = $('input', $(this.target));
        const inputValue = $inputElement.val();
        $inputElement.val('');

        // Initialize picker
        const mergedOptions = $.extend(true, this.options(), $(this.target).data('picker-options') ?? {});
        const picker = new TempusDominus(this.target, mergedOptions);

        // Revert temporary changes
        $inputElement.val(inputValue);
        $(this.target).show();

        // Handle invalid value when input changes. There should be another way to handel this in the next release: https://github.com/Eonasdan/tempus-dominus/issues/2793
        // @ts-ignore
        picker.dates.previousParseInput = picker.dates.parseInput;
        picker.dates.parseInput = (value: any) => {
            try {
                // @ts-ignore
                return picker.dates.previousParseInput(value);
            } catch (e) {
                // Keep the previous value, and log the error
                console.warn('DatePicker: Error parsing input value:', e);
                return null;
            }
        };

    }
}

// noinspection JSUnusedGlobalSymbols
export default () => {
    for (const $datePickerElement of $('.datepicker')) {
        if ($datePickerElement.id === birthdayDateElementID) {
            $($datePickerElement).data('picker-options').defaultDate = new Date('2000-01-01');
            $($datePickerElement).data('picker-options').restrictions = {
                minDate: new Date('1940-01-01'),
                maxDate: new Date('2007-12-31')
            };
            $('input', $datePickerElement).attr('placeholder', 'dd.mm.yyyy');
            new DatePicker($datePickerElement).createPicker();
        } else {
            new SlDatePicker($datePickerElement).createPicker();
        }
    }
}